<script setup>
import {useUserSettingStore} from "@/stores/userSetting.store";
import {storeToRefs} from "pinia/dist/pinia";
import {onMounted} from "vue";
import {useGlobalStore} from "@/stores/global.store";

const globalStore = useGlobalStore();
const userSettingStore = useUserSettingStore();
const {userNotificationSettings} = storeToRefs(userSettingStore);

onMounted(async () => {
    globalStore.loading = true;
    await userSettingStore.fetchAll();
    globalStore.loading = false;
});

const toggleNotification = async (notificationGroupId, enabled) => {
    let action = 'enable';

    if (!enabled) {
        action = 'disable';
    }

    console.log(action + ' notification group ' + notificationGroupId);

    await userSettingStore.updateResource(notificationGroupId, action);
};
</script>

<template>
    <van-space direction="vertical" fill>
        <div v-if="userNotificationSettings.length === 0">
            <van-empty image="search" description="Nothing found"/>
        </div>
        <div v-if="userNotificationSettings.length > 0">
            <van-cell-group inset v-for="userNotificationSetting in userNotificationSettings"
                            :key="userNotificationSetting.id">
                <van-cell>
                    <template #title>
                        <b>{{ userNotificationSetting.notification_group.name }}</b>
                    </template>
                    <template #right-icon>
                        <van-switch v-model="userNotificationSetting.enabled"
                                    @change="toggleNotification(userNotificationSetting.notification_group.id, userNotificationSetting.enabled)"/>
                    </template>
                </van-cell>
                <van-row>&nbsp;</van-row>
            </van-cell-group>
        </div>
    </van-space>
</template>
